import { Loading, PageHeader } from '@/components'
import { Box, Tab, TabProps, Tabs, Typography } from '@mui/material'
import { useRouteMatch } from '@/hooks'
import { generatePath, Link, Outlet, useParams } from 'react-router-dom'
import { useReadPartner } from '@/api/accounting-dealer'
import { useCompany } from '@/context/companies'
import { routes } from '@/router'

export function PartnerPage() {
  const { partner_key } = useParams()

  const { company } = useCompany()

  const TAB_ROUTES = {
    data: '/partners/:partner_key/data',
    dependants: '/partners/:partner_key/dependants',
  }

  const routeMatch = useRouteMatch(Object.values(TAB_ROUTES))
  const currentTab = routeMatch?.pattern?.path

  const { data: partner, isLoading: isReadingPartner } = useReadPartner({
    partnerKey: partner_key!,
    companyKey: company.key,
  })

  return (
    <>
      <PageHeader rollbackRoute={routes.partners.index}>Sócios</PageHeader>

      {isReadingPartner ? (
        <Loading />
      ) : (
        <>
          <Typography variant="h3" textAlign="center" mb={2}>
            {partner?.name}
          </Typography>

          <Tabs value={currentTab} variant="fullWidth">
            <LinkTab
              label="Dados do sócio"
              value={TAB_ROUTES.data}
              to={generatePath(TAB_ROUTES.data, { partner_key: partner_key! })}
            />
            <LinkTab
              label="Dependentes"
              value={TAB_ROUTES.dependants}
              to={generatePath(TAB_ROUTES.dependants, {
                partner_key: partner_key!,
              })}
            />
          </Tabs>

          <Box sx={{ my: 2 }}>
            <Outlet context={partner} />
          </Box>
        </>
      )}
    </>
  )
}

const LinkTab = (props: TabProps & { to: string }) => {
  return <Tab component={Link} {...props} />
}
